import { render, staticRenderFns } from "./TravelPreview.vue?vue&type=template&id=6f87fa15&scoped=true&"
import script from "./TravelPreview.vue?vue&type=script&lang=js&"
export * from "./TravelPreview.vue?vue&type=script&lang=js&"
import style0 from "./TravelPreview.vue?vue&type=style&index=0&id=6f87fa15&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f87fa15",
  null
  
)

export default component.exports